import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import { PulseLoader } from 'react-spinners';
import { FaAngleRight } from 'react-icons/fa';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import * as actions from '../../../actions';
import { editUser } from '../../../queries';

import Footer from '../../../components/Footer';

import {
  Breadcrumb,
  Wrapper,
  Row,
  Label,
  Input,
  Button,
} from '../../../assets/styles';

class UserAccount extends Component {
  state = {
    name: '',
    email: '',
    password: '',
    newPassword: '',
    confirmNewPassword: '',
  };

  componentDidMount = () => {
    this.setState({
      name: this.props.user.name,
      email: this.props.user.email,
    });
  }

  handleSubmit = async () => {
    await this.validateInputs();

    const {
      nameError,
      emailError,
      passwordError,
      newPasswordError,
      confirmNewPasswordError,
    } = this.state;

    if (
      !nameError
      && !emailError
      && !passwordError
      && !newPasswordError
      && !confirmNewPasswordError
    ) {
      this.setState({ loading: true });

      const { email, password, newPassword } = this.state;

      this.props
        .editUser({
          variables: {
            id: this.props.user.id,
            email,
            password,
            newPassword,
          },
        })
        .then(async () => {
          this.props.alert.success('Informações salvas com sucesso');
          this.props.saveUser({ email: this.state.email });

          this.setState({
            loading: false,
            password: '',
            newPassword: '',
            confirmNewPassword: '',
          });
        })
        .catch((e) => {
          this.setState({ loading: false });

          if (/email/i.test(e.message)) this.setState({ emailInvalid: true, emailError: true });
          if (/incorrect/i.test(e.message)) this.setState({ passwordInvalid: true, passwordError: true });
          if (/equal/i.test(e.message)) this.setState({ newPasswordError: true, newPasswordEqual: true });
        });
    }
  }

  validateInputs = async () => {
    const {
      name,
      email,
      password,
      newPassword,
      confirmNewPassword,
    } = this.state;

    this.setState({
      nameError: false,
      emailError: false,
      emailInvalid: false,
      passwordError: false,
      passwordInvalid: false,
      newPasswordError: false,
      newPasswordLength: false,
      newPasswordEqual: false,
      confirmNewPasswordError: false,
      confirmNewPasswordInvalid: false,
    });

    const nameReg = /^[^\s][A-zÀ-ÿ0-9]*((-|\s)*[_A-zÀ-ÿ0-9])*$/;
    if (!nameReg.test(name)) this.setState({ nameError: true });

    const emailReg = /^[a-z0-9][a-z0-9-_.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/;
    if (!emailReg.test(email)) this.setState({ emailError: true });

    if (password.length < 6) this.setState({ passwordError: true });

    if (newPassword.length !== 0 && newPassword.length < 6) {
      this.setState({ newPasswordError: true, newPasswordLength: true });
    }

    if (newPassword !== confirmNewPassword) {
      this.setState({ confirmNewPasswordError: true, confirmNewPasswordInvalid: true });
    }
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      loading,
      name,
      email,
      password,
      newPassword,
      confirmNewPassword,
      nameError,
      nameFocus,
      emailFocus,
      emailError,
      emailInvalid,
      passwordError,
      passwordInvalid,
      passwordFocus,
      newPasswordError,
      newPasswordFocus,
      newPasswordEqual,
      newPasswordLength,
      confirmNewPasswordError,
      confirmNewPasswordInvalid,
      confirmNewPasswordFocus,
    } = this.state;

    return (
      <div style={{ position: 'absolute', width: '100%' }}>
        <MetaTags>
          <title>Meus dados - Portal da Loja - Reforma Fácil</title>
          <meta name="robots" content="noindex" />
        </MetaTags>
        <Breadcrumb>
          <div className="container">
            <h2>Meus dados</h2>
          </div>
        </Breadcrumb>
        <Wrapper>
          <Row>
            <div className="row-2">
              <Label>
                <p className="fieldName">
                  {'Nome'}
                  <span className="required">*</span>
                </p>
                <Input
                  readOnly
                  type="text"
                  name="name"
                  value={name}
                  error={nameError}
                  onFocusInput={nameFocus}
                  // onChange={this.handleInputChange}
                  // onFocus={() => this.onFocus('nameFocus')}
                  // onBlur={() => this.onBlur('nameFocus')}
                />
              </Label>
              <Label>
                <p className="fieldName">
                  {'E-mail'}
                  <span className="required">*</span>
                </p>
                <Input
                  type="email"
                  name="email"
                  value={email}
                  error={emailError}
                  onFocusInput={emailFocus}
                  onChange={this.handleInputChange}
                  onFocus={() => this.onFocus('emailFocus')}
                  onBlur={() => this.onBlur('emailFocus')}
                />
                {emailInvalid && <p className="inputMessage errorMessage">O e-mail informado já está em uso</p>}
              </Label>
            </div>
            <div className="row-2">
              <Label>
                <p className="fieldName">
                  {'Senha atual'}
                  <span className="required">*</span>
                </p>
                <Input
                  type="password"
                  name="password"
                  value={password}
                  error={passwordError}
                  onFocusInput={passwordFocus}
                  onChange={this.handleInputChange}
                  onFocus={() => this.onFocus('passwordFocus')}
                  onBlur={() => this.onBlur('passwordFocus')}
                />
                {passwordInvalid && <p className="inputMessage errorMessage">A senha está incorreta</p>}
              </Label>
              <Label style={{ marginBottom: 0 }} />
            </div>
            <div className="row-2">
              <Label>
                <p className="fieldName">Nova senha</p>
                <Input
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  error={newPasswordError}
                  onFocusInput={newPasswordFocus}
                  onChange={this.handleInputChange}
                  onFocus={() => this.onFocus('newPasswordFocus')}
                  onBlur={() => this.onBlur('newPasswordFocus')}
                />
                {newPasswordEqual && <p className="inputMessage errorMessage">A nova senha não pode ser igual a antiga</p>}
                {newPasswordLength && <p className="inputMessage errorMessage">A senha deve conter no mínimo 6 caracteres</p>}
              </Label>
              <Label>
                <p className="fieldName">Confirmar nova senha</p>
                <Input
                  type="password"
                  name="confirmNewPassword"
                  value={confirmNewPassword}
                  error={confirmNewPasswordError}
                  onFocusInput={confirmNewPasswordFocus}
                  onChange={this.handleInputChange}
                  onFocus={() => this.onFocus('confirmNewPasswordFocus')}
                  onBlur={() => this.onBlur('confirmNewPasswordFocus')}
                />
                {confirmNewPasswordInvalid && <p className="inputMessage errorMessage">As senhas não correspondem</p>}
              </Label>
            </div>
            <Button type="submit" disabled={loading} onClick={this.handleSubmit}>
              {!loading ? (
                <span>
                  {'Salvar'}
                  <FaAngleRight className="fa fa-angle-right" />
                </span>
              ) : (
                <PulseLoader
                  sizeUnit="px"
                  size={7}
                  color="#FFFFFF"
                  loading={loading}
                  style={{ paddingLeft: '25px' }}
                />
              )}
            </Button>
          </Row>
          <Footer />
        </Wrapper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispathToProps = dispatch => bindActionCreators(actions, dispatch);

export default compose(
  connect(mapStateToProps, mapDispathToProps),
  withAlert(),
  graphql(editUser, { name: 'editUser' }),
)(UserAccount);
